import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_APPOINTMENT_BY_TOKEN } from "../../../../../../../queries/v3/pages/CancelAppointment/queries/get-appointment-by-token.js";
import { fromAppointmentQueryToAppointment } from "../../../../../adapters/v3/pages/CancelAppointment/hooks/api/adapters/fromAppointmentQueryToAppointment.js";
const useAppointmentByToken = (variables) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_TOKEN, {
    variables,
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    }
  });
  const data = React.useMemo(() => {
    return queryState.data?.appointmentByToken ? fromAppointmentQueryToAppointment(queryState.data.appointmentByToken) : null;
  }, [queryState]);
  return React.useMemo(
    () => [
      query,
      {
        ...queryState,
        data
      }
    ],
    [data, queryState, query]
  );
};
export {
  useAppointmentByToken as default
};
//# sourceMappingURL=use-appointment-by-token.js.map
